import React, { useState, useEffect } from "react";
import "./CQStudentQuizResult.css";
import moment from "moment-timezone";
import Spinner from "../../Spinner/Spinner";
import InnerHTML from "dangerously-set-html-content";
import loaderColors1 from "../../Spinner/loaderColors1.gif";
import {
  handleResponse,
  handleJwtTokenForKeppMeLoggedIn,
} from "../../../app/util/HOC";
import QuizResultPieChart from "./QuizResultPieChart";
import { CHECKBOX } from "./utils";
export default function CQStudentQuizResult(props) {
  var qrClassID = props.data.studClassId,
    qrQuizId = props.data.studQuizId,
    qrPublish = props.data.studQuizPublish,
    qrRelOpt = props.data.studQuizRelOpt,
    qrRelED = props.data.studQuizED,
    qrRelRD = props.data.studQuizRD,
    qrAfterRelRD = props.data.studQuizAfterRD,
    qrRelCD = props.data.studQuizCD,
    qrCompletedDate = props.data.studQuizComD;
  const userVO = JSON.parse(localStorage.getItem("userVO"));
  const currentDateTime = moment(new Date()).format("YYYY-MM-DD HH:mm");
  const keepMeLogIn = localStorage.getItem("keepLoggedIn") ? "true" : "false";
  const authToken = userVO.apJwtAuthenticationToken
    ? userVO.apJwtAuthenticationToken
    : localStorage.getItem("apJwtAuthenticationToken");
  var qrStatusMsg =
    qrPublish === false
      ? qrRelOpt === "quiz_end"
        ? qrRelED > currentDateTime
          ? "Your detailed results will be available after the quiz end date."
          : null
        : qrRelOpt === "date_range"
          ? qrRelRD > currentDateTime
            ? "Your detailed results will be available on " + qrAfterRelRD + "."
            : qrRelCD <= currentDateTime
              ? "The timeframe to view your detailed results has been closed by your professor."
              : null
          : null
      : null;
  const [expandAll, setExpandAll] = useState(false);
  const [quizTakerShow, setQuizTakerShow] = useState(false);
  const [quizResultShow, setQuizResultShow] = useState(true);
  const [isResultLoading, setIsResultLoading] = useState(true);
  const [summaryQuizResult, setSummaryQuizResult] = useState([]);
  const [detailQuizResultTW, setDetailQuizResultTW] = useState([]);
  const [detailQuizResultOW, setDetailQuizResultOW] = useState([]);
  const [detailQuizResultSort, setDetailQuizResultSort] =
    useState("topicPerformance");
  const getSessionVO = () => {
    return {
      appType: "web",
      deviceMacId: "",
      keepMeLoggedInFlag: keepMeLogIn,
      deviceOS: localStorage.getItem("deviceOS"),
      deviceType: localStorage.getItem("deviceType"),
      browserName: localStorage.getItem("browserName"),
      sessionAuthenticationToken: userVO.sessionAuthenticationToken,
    };
  };

  function fetchSummaryQuizResult() {
    var reqData = {
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        schoolId: userVO.schoolId,
        userRoleId: userVO.userRoleId,
        keepMeLoggedInFlag: keepMeLogIn,
        userActivityVO: {
          lastReadBookId: "",
          lastReadPageNum: "",
          lastReadChapterId: "",
          lastReadSectionId: "",
          lastReadParagraphId: "",
          lastViewedOutlineId: "",
          lastReadSubSectionId: "",
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "EReader",
          pageNavigatingTo: "Bookshelf",
        },
        sessionVO: getSessionVO(),
      },
      classV: { classId: qrClassID },
      quizDetails: { identifier: qrQuizId },
    };
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(reqData),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    };
    fetch(
      `${localStorage.getItem("qpAPI")}/quiz/api/V2/get-QuizDetails`,
      requestOptions,
    )
      .then(handleResponse)
      .then((response) => response.json())
      .then(handleJwtTokenForKeppMeLoggedIn)
      .then((data) => {
        if (data && data[0]) {
          setSummaryQuizResult(data);
          document.title = `View Results | ${data[0].QuizName} | ${data[0].ClassName} | Connected Quizzing`;
          if (qrStatusMsg !== null) {
            setIsResultLoading(false);
          }
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  }
  function fetchDetailQuizResultTopicWise() {
    var reqData = {
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        schoolId: userVO.schoolId,
        userRoleId: userVO.userRoleId,
        keepMeLoggedInFlag: keepMeLogIn,
        userActivityVO: {
          lastReadBookId: "",
          lastReadPageNum: "",
          lastReadChapterId: "",
          lastReadSectionId: "",
          lastReadParagraphId: "",
          lastViewedOutlineId: "",
          lastReadSubSectionId: "",
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "EReader",
          pageNavigatingTo: "Bookshelf",
        },
        sessionVO: getSessionVO(),
      },
      classV: { classId: qrClassID },
      quizModel: { identifier: qrQuizId },
    };
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(reqData),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    };
    fetch(
      `${localStorage.getItem("qpAPI")}/quiz/api/V2/summaryTopicWise`,
      requestOptions,
    )
      .then(handleResponse)
      .then((response) => response.json())
      .then(handleJwtTokenForKeppMeLoggedIn)
      .then((data) => {
        if (data) {
          var topic_wise_summary = data.topic_wise_summary.map((topicSumm) => {
            topicSumm.questionList = topicSumm.questionList.map(
              (topicSummQues) => {
                return { ...topicSummQues, ques_expand_status: false };
              },
            );
            return { ...topicSumm, topic_expand_status: false };
          });
          setDetailQuizResultTW(topic_wise_summary);
          setIsResultLoading(false);
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  }
  function fetchDetailQuizResultOrderWise() {
    var reqData = {
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        schoolId: userVO.schoolId,
        userRoleId: userVO.userRoleId,
        keepMeLoggedInFlag: keepMeLogIn,
        userActivityVO: {
          lastReadBookId: "",
          lastReadPageNum: "",
          lastReadChapterId: "",
          lastReadSectionId: "",
          lastReadParagraphId: "",
          lastViewedOutlineId: "",
          lastReadSubSectionId: "",
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "EReader",
          pageNavigatingTo: "Bookshelf",
        },
        sessionVO: getSessionVO(),
      },
      classV: { classId: qrClassID },
      quizModel: { identifier: qrQuizId },
    };
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(reqData),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    };
    fetch(
      `${localStorage.getItem("qpAPI")}/quiz/api/V2/summaryOrderWise`,
      requestOptions,
    )
      .then(handleResponse)
      .then((response) => response.json())
      .then(handleJwtTokenForKeppMeLoggedIn)
      .then((data) => {
        if (data) {
          var order_wise_summary = data.order_wise_summary.questionList.map(
            (topicOrder) => {
              return { ...topicOrder, owques_expand_status: false };
            },
          );
          setDetailQuizResultOW(order_wise_summary);
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  }
  useEffect(() => {
    fetchSummaryQuizResult();
    if (qrStatusMsg === null) {
      fetchDetailQuizResultTopicWise();
      fetchDetailQuizResultOrderWise();
    }
  }, []);
  function handleBackToAssignment() {
    setQuizTakerShow(props.displayQuizTaker);
    setQuizResultShow(props.displayQuizResult);
  }
  function convertSecondsToHMS(value) {
    const sec = parseInt(value, 10);
    let hrs = Math.floor(sec / 3600);
    let mins = Math.floor((sec - hrs * 3600) / 60);
    let secs = sec - hrs * 3600 - mins * 60;
    if (mins < 10) {
      mins = "0" + mins;
    }
    if (secs < 10) {
      secs = "0" + secs;
    }
    return hrs + "h " + mins + "m " + secs + "s";
  }
  function dateTimeModification(beforeFormatDT) {
    var afterFDTZone = moment.tz.guess(),
      afterFDT = moment.utc(beforeFormatDT).clone().tz(afterFDTZone),
      afterFormatDT = moment(afterFDT).format("MMMM DD, YYYY - hh:mm A z");
    return afterFormatDT.replace("-", "at");
  }
  function dateTimeConversion(beforeFormatDateTime) {
    var beforeFT =
      beforeFormatDateTime === null ? qrCompletedDate : beforeFormatDateTime;
    var afterFormatDateTime = dateTimeModification(beforeFT);
    if (afterFormatDateTime.includes("AM")) {
      afterFormatDateTime = afterFormatDateTime.replace("AM", "a.m.");
    } else {
      afterFormatDateTime = afterFormatDateTime.replace("PM", "p.m.");
    }
    return afterFormatDateTime.split("at");
  }

  function handleDetailResultTWExpandAll(topicValue, topicExpandSt) {
    const newTopicState = detailQuizResultTW.map((detailQRData) => {
      if (detailQRData.topic_name === topicValue) {
        if (topicExpandSt === true) {
          detailQRData.questionList = detailQRData.questionList.map(
            (detailQRQues) => {
              return { ...detailQRQues, ques_expand_status: true };
            },
          );
        } else {
          detailQRData.questionList = detailQRData.questionList.map(
            (detailQRQues) => {
              return { ...detailQRQues, ques_expand_status: false };
            },
          );
        }
        return { ...detailQRData, topic_expand_status: topicExpandSt };
      }
      return detailQRData;
    });
    setDetailQuizResultTW(newTopicState);
  }
  function handleDetailResultTWExpandQuestion(
    topicValue,
    quesNo,
    quesExpandSt,
  ) {
    var newTopicQuesState = detailQuizResultTW.map((detailQRData) => {
      if (detailQRData.topic_name === topicValue) {
        detailQRData.questionList = detailQRData.questionList.map(
          (detailQRQues) => {
            if (detailQRQues.questionOrder === quesNo) {
              return { ...detailQRQues, ques_expand_status: quesExpandSt };
            }
            return detailQRQues;
          },
        );
      }
      return detailQRData;
    });
    setDetailQuizResultTW(newTopicQuesState);
  }
  function handleDetailResultOWExpandAll(quesExpandSt) {
    setExpandAll(quesExpandSt);
    const newQuesExpandState = detailQuizResultOW.map((detailQRQWData) => {
      if (quesExpandSt === true) {
        return { ...detailQRQWData, owques_expand_status: true };
      } else {
        return { ...detailQRQWData, owques_expand_status: false };
      }
    });
    setDetailQuizResultOW(newQuesExpandState);
  }
  function handleDetailResultOWExpandQues(quesNo, quesExpandSt) {
    const newQuesExpandState = detailQuizResultOW.map((detailQRQWData) => {
      if (detailQRQWData.questionOrder === quesNo) {
        return { ...detailQRQWData, owques_expand_status: quesExpandSt };
      }
      return detailQRQWData;
    });
    setDetailQuizResultOW(newQuesExpandState);
  }
  function svgAttributeAdd(qaSvg) {
    let getParentClsSvg = document.querySelector(qaSvg);
    let getSvgDiv = getParentClsSvg.querySelector("svg");
    getSvgDiv.setAttribute("aria-disabled", true);
  }
  const shouldShowComma = (index, totalLength) => {
    return index < totalLength - 1;
  };

  return (
    <>
      <Spinner
        loading={isResultLoading}
        imageSrc={loaderColors1}
        overlayBackground="rgba(0,0,0,0.5)"
      />
      <main>
        <div className="container">
          <div className="card cqStudQrContainerSection">
            <div className="card-body cqStudQrContainerCard">
              <div className="row">
                <div className="col-xl-7 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                  <div className="cqStudQrLogoContainer col-xl-7 col-lg-8 col-md-10 col-sm-12 col-xs-12">
                    <img
                      className="cqStudQrLogo"
                      src="/cc/images/CQ_logo_grey_screen.png"
                      alt="Connected Quizzing"
                    ></img>
                  </div>
                </div>
              </div>
              <div className="cqStudQrSummaryDiv">
                {summaryQuizResult &&
                  summaryQuizResult.map((qrData, indexqrData) => {
                    console.log("PartiallyCorrect", qrData);
                    return (
                      <div key={indexqrData}>
                        <div className="pt-4">
                          <h1 className="cqStudQrTitle">{qrData.QuizName}</h1>
                          <p className="cqStudQrText">
                            <span>{qrData.SemesterName}</span> |
                            <span> Professor {qrData.ProfessorName}</span>
                            {qrData.AssistantProf.length > 0 ? (
                              <span>
                                ,
                                {qrData.AssistantProf.map(
                                  (cqClassStud, index) => {
                                    return (
                                      <span key={index}>
                                        {cqClassStud.UserRole === "Student"
                                          ? ` Assistant `
                                          : ` Professor `}
                                        {cqClassStud.LastName}
                                        {index !==
                                          qrData.AssistantProf.length - 1 &&
                                          ", "}
                                      </span>
                                    );
                                  },
                                )}
                              </span>
                            ) : null}{" "}
                            |<span> Class: {qrData.ClassName}</span>
                          </p>
                          <button
                            className="btn cqStudQrBackBtn"
                            onClick={handleBackToAssignment}
                          >
                            Back to Assignments
                          </button>
                          <p className="cqStudQrStatusMsg pt-2">
                            {qrStatusMsg}
                          </p>
                        </div>
                        <div className="row">
                          <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 mb-3">
                            <div className="cqStudQrCard p-4">
                              <p
                                className="cqStudQrText m-0"
                                role="heading"
                                aria-level="2"
                              >
                                Your Score:
                              </p>
                              <p className="cqStudQrPercent m-0">
                                {Number(qrData.score).toFixed(2) + "%"}
                              </p>
                              <div className="progress cqStudQrScoreProgr">
                                <div
                                  className="progress-bar cqStudQrScoreProgrBar"
                                  style={{
                                    width:
                                      Number(qrData.score).toFixed(2) + "%",
                                  }}
                                ></div>
                              </div>
                              <p
                                className="cqStudQrText mt-2"
                                role="heading"
                                aria-level="2"
                              >
                                Class Average:
                              </p>
                              <p className="cqStudQrAvgScore m-0">
                                {Number(qrData.ClassAverage).toFixed(2) + "%"}
                              </p>
                              <div className="progress cqStudQrAvgProgr">
                                <div
                                  className="progress-bar cqStudQrAvgProgrBar"
                                  style={{
                                    width:
                                      Number(qrData.ClassAverage.toFixed(2)) +
                                      "%",
                                  }}
                                ></div>
                              </div>
                            </div>
                          </div>
                          <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 mb-3">
                            <div className="cqStudQrCard p-4">
                              <p
                                className="cqStudQrText m-0"
                                role="heading"
                                aria-level="2"
                              >
                                Time Spent:
                              </p>
                              <p className="cqStudQrTimeSpent m-0">
                                {convertSecondsToHMS(qrData.totalTimeSpent)}
                              </p>
                              <p
                                className="cqStudQrText my-2"
                                role="heading"
                                aria-level="2"
                              >
                                Date Submitted:
                              </p>
                              <p className="cqStudQrAvgScore mb-3">
                                {dateTimeConversion(qrData.completedDate)[0]}
                              </p>
                              <p
                                className="cqStudQrText"
                                role="heading"
                                aria-level="2"
                              >
                                Time Submitted:
                              </p>
                              <p className="cqStudQrAvgScore m-0">
                                {dateTimeConversion(qrData.completedDate)[1]}
                              </p>
                            </div>
                          </div>
                          <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 mb-3 mx-xl-0 mx-lg-0 mx-md-auto mx-sm-auto mx-0">
                            <div className="cqStudQrCard p-4">
                              <p
                                className="cqStudQrText m-0"
                                role="heading"
                                aria-level="2"
                              >
                                Questions Answered:
                              </p>
                              <p className="cqStudQrAvgScore m-0 mt-2">
                                {qrData.totalAnswered} of{" "}
                                {qrData.numberOfQuestions}
                              </p>
                              <div
                                data-testid="pie_chart"
                                id="qaSvg"
                                style={{ width: "5rem", margin: "auto" }}
                                aria-disabled="true"
                                onClick={() => svgAttributeAdd("#qaSvg")}
                              >
                                <QuizResultPieChart
                                  noOfPartialAnswered={qrData.PartiallyCorrect}
                                  nofInCorr={qrData.incorrect}
                                  nofUnAns={qrData.totalUnAnswered}
                                  nofCorr={qrData.correct}
                                />
                              </div>
                              <p className="cqStudQrPieTxt mt-2">
                                <span className="d-block">
                                  {qrData.correct} Correct
                                </span>
                                <span className="d-block">
                                  {qrData?.PartiallyCorrect || 0} Partially
                                  Correct
                                </span>
                                <span className="d-block">
                                  {qrData.incorrect} Incorrect
                                </span>
                                <span>{qrData.totalUnAnswered} Unanswered</span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </div>
              {isResultLoading === false && (
                <div className="cqStudQrDetailedDiv">
                  {qrStatusMsg === null ? (
                    <>
                      {
                        <div className="row">
                          <div className=" col-xl-7 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <div className="cqStudQrTitleContainer col-xl-7 col-lg-8 col-md-10 col-sm-12 col-xs-12">
                              <h2 className="cqStudQrTitle">
                                Detailed Quiz Results
                              </h2>
                            </div>
                          </div>
                          <div className="col-xl-5 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <div className="cqStudQrViewingContainer row">
                              <div className="cqStudQrViewingLabel col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 pl-3">
                                <p className="cqStudQrSortBY text-xl-right text-lg-right text-md-right  text-sm-left text-left">
                                  Sort By:
                                </p>
                              </div>
                              <div
                                className="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-9"
                                style={{ paddingRight: "9px" }}
                              >
                                <select
                                  data-testid="sort_detailed_quiz_result"
                                  aria-label="Sort by"
                                  className="cqStudQrViewingInput form-control"
                                  onChange={(e) =>
                                    setDetailQuizResultSort(e.target.value)
                                  }
                                >
                                  <option value="topicPerformance">
                                    Topic Performance
                                  </option>
                                  <option value="quizQuestionOrder">
                                    Quiz Question Order
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                      {detailQuizResultSort === "topicPerformance" ? (
                        <div className="row border-bottom pb-2 mb-2">
                          <div className="col">
                            {detailQuizResultTW.map(
                              (detailQRData, indexdetailQRData) => {
                                return (
                                  <div key={indexdetailQRData}>
                                    <div className="cqStudQrText mb-2">
                                      {detailQRData.topic_name}
                                    </div>
                                    <div className="progress cqStudQrProgress">
                                      {Number(detailQRData.user_topic_score) >
                                      0 ? (
                                        <>
                                          <div
                                            className="progress-bar cqStudQrProgressBar"
                                            style={{
                                              width:
                                                Number(
                                                  detailQRData.user_topic_score,
                                                ) + "%",
                                            }}
                                          >
                                            {Number(
                                              detailQRData.user_topic_score,
                                            ) > 16
                                              ? Number(
                                                  detailQRData.user_topic_score,
                                                ) + "%"
                                              : null}
                                          </div>
                                          {Number(
                                            detailQRData.user_topic_score,
                                          ) > 16 ? null : (
                                            <div className="progress-bar cqStudQrProgressBarLess16">
                                              {Number(
                                                detailQRData.user_topic_score,
                                              ) + "%"}
                                            </div>
                                          )}
                                        </>
                                      ) : (
                                        <div className="progress-bar cqStudQrProgressBarNo">
                                          {Number(
                                            detailQRData.user_topic_score,
                                          ) + "%"}
                                        </div>
                                      )}
                                    </div>
                                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 no-padding mb-2">
                                      <span
                                        className="cqStudQrToolTip"
                                        style={{
                                          marginLeft:
                                            Number(
                                              detailQRData.class_topic_avg_score,
                                            ) <= 97
                                              ? Number(
                                                  detailQRData.class_topic_avg_score,
                                                ).toFixed(0) -
                                                1 +
                                                "%"
                                              : "95%",
                                        }}
                                      >
                                        <span className="progresss-bar"></span>
                                        <span
                                          style={{
                                            marginTop: "-69px",
                                            marginLeft: "-83px",
                                          }}
                                          className="cqStudQrToolTipText"
                                        >
                                          <span className="cqStudQrClassAvgText">
                                            Class Average:
                                          </span>
                                          <br></br>
                                          <span className="cqStudQrClassAvgPer">
                                            {Number(
                                              detailQRData.class_topic_avg_score,
                                            ) + "%"}
                                          </span>
                                        </span>
                                      </span>
                                    </div>
                                    <button
                                      style={{
                                        border: "none",
                                        padding: "0%",
                                        background: "none",
                                      }}
                                      onClick={() =>
                                        handleDetailResultTWExpandAll(
                                          detailQRData.topic_name,
                                          detailQRData.topic_expand_status ===
                                            true
                                            ? false
                                            : true,
                                        )
                                      }
                                      aria-expanded={detailQRData.topic_expand_status ===
                                        true}
                                      aria-label={
                                        detailQRData.topic_expand_status ===
                                        true
                                          ? "Collapse all questions"
                                          : "Expand all questions"
                                      }
                                    >
                                      <span
                                        id={detailQRData.topic_name}
                                        className="cqStudQrClassQuesExp"
                                      >
                                        {detailQRData.topic_expand_status ===
                                        true
                                          ? "Collapse all questions"
                                          : "Expand all questions"}
                                      </span>
                                    </button>
                                    <div className="card card-body">
                                      <ol
                                        className="m-0 p-0"
                                        style={{ listStyleType: "none" }}
                                      >
                                        {detailQRData.questionList.map(
                                          (detailQRQues, index) => {
                                            const rawUserAnswers =
                                              detailQRQues.UserSelectedanswerList ||
                                              [];

                                            // Remove invalid answers (empty choice, null, undefined)
                                            const validUserAnswers =
                                              rawUserAnswers.filter(
                                                (ans) =>
                                                  ans.choice &&
                                                  ans.choice.trim() !== "",
                                              );
                                            // Map: choiceId -> correct
                                            const answerMap =
                                              validUserAnswers.reduce(
                                                (acc, ans) => {
                                                  acc[ans.choice] = ans.correct;
                                                  return acc;
                                                },
                                                {},
                                              );
                                            const hasValidAnswer =
                                              validUserAnswers.length > 0;

                                            const isMultiSelect =
                                              detailQRQues.itemTypeName ===
                                              CHECKBOX;

                                            const answeredOptions =
                                              detailQRQues.choiceInteraction?.simpleChoices
                                                ?.filter((opt) =>
                                                  answerMap.hasOwnProperty(
                                                    opt.identifier,
                                                  ),
                                                )
                                                .map((opt) => ({
                                                  label: opt.label,
                                                  isCorrect:
                                                    answerMap[opt.identifier],
                                                })) || [];
                                            const EXPECTED_COUNT = isMultiSelect
                                              ? 2
                                              : answeredOptions.length;
                                            const paddedAnswers = [
                                              ...answeredOptions,
                                            ];

                                            while (
                                              paddedAnswers.length <
                                              EXPECTED_COUNT
                                            ) {
                                              paddedAnswers.push({
                                                label: "N/A",
                                                isNA: true,
                                              });
                                            }

                                            const expectedCount = isMultiSelect
                                              ? 2
                                              : 1;
                                            const rawAnsweredCount =
                                              validUserAnswers.length;
                                            const isPartialAnswered =
                                              isMultiSelect &&
                                              rawAnsweredCount > 0 &&
                                              rawAnsweredCount < expectedCount;
                                            return (
                                              <>
                                                <li key={index}>
                                                  <div
                                                    onKeyDown={(e) => {
                                                      if (e.key === "Enter") {
                                                        handleDetailResultTWExpandQuestion(
                                                          detailQRData.topic_name,
                                                          detailQRQues.questionOrder,
                                                          detailQRQues.ques_expand_status ===
                                                            true
                                                            ? false
                                                            : true,
                                                        );
                                                      }
                                                    }}
                                                    className="cqStudQrTextQuizzes row mb-2"
                                                    tabIndex={0}
                                                    role="button"
                                                    onClick={() =>
                                                      handleDetailResultTWExpandQuestion(
                                                        detailQRData.topic_name,
                                                        detailQRQues.questionOrder,
                                                        detailQRQues.ques_expand_status ===
                                                          true
                                                          ? false
                                                          : true,
                                                      )
                                                    }
                                                    aria-expanded={
                                                      detailQRQues.ques_expand_status ===
                                                      true
                                                        ? true
                                                        : false
                                                    }
                                                    aria-disabled={
                                                      detailQRQues.ques_expand_status ===
                                                      true
                                                        ? true
                                                        : false
                                                    }
                                                  >
                                                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ">
                                                      <div
                                                        className="cqStudQrDisplayBlock col-xl-1 col-lg-1 col-md-1 col-sm-2 col-2 pl-xl-3 pl-lg-2 pl-md-2 pl-0 pr-0"
                                                        style={{
                                                          cursor: "pointer",
                                                        }}
                                                      >
                                                        {detailQRQues.questionOrder +
                                                          ". "}
                                                      </div>
                                                      <div
                                                        className="col-xl-1 col-lg-2 col-md-2 col-sm-4 col-4 no-padding float-right"
                                                        style={{
                                                          cursor: "pointer",
                                                        }}
                                                      >
                                                        {/* Tick Box Container */}
                                                        <span
                                                          className="cqStudQrAnswerText"
                                                          style={{
                                                            display: "flex",
                                                            gap: "0px",
                                                          }}
                                                        >
                                                          {hasValidAnswer ? (
                                                            paddedAnswers.map(
                                                              (ans, index) => (
                                                                <span
                                                                  key={index}
                                                                  style={{
                                                                    display:
                                                                      "flex",
                                                                    alignItems:
                                                                      "center",
                                                                  }}
                                                                >
                                                                  {/* ICON + LABEL */}
                                                                  {ans.isNA ? (
                                                                    <div
                                                                      style={{
                                                                        display:
                                                                          "flex",
                                                                        alignItems:
                                                                          "center",
                                                                      }}
                                                                    >
                                                                      <i
                                                                        className="fas fa-times cqStudQrCheckIcon text-danger"
                                                                        title="Not answered"
                                                                      />
                                                                      <span>
                                                                        N/A
                                                                      </span>
                                                                    </div>
                                                                  ) : ans.isCorrect ? (
                                                                    <div
                                                                      style={{
                                                                        display:
                                                                          "flex",
                                                                        alignItems:
                                                                          "center",
                                                                      }}
                                                                    >
                                                                      <i
                                                                        className="fas fa-check cqStudQrCheckIcon"
                                                                        title="Correct answer"
                                                                      />
                                                                      <span>
                                                                        {ans.label.replace(
                                                                          /[\])}[{(]/g,
                                                                          "",
                                                                        )}
                                                                      </span>
                                                                    </div>
                                                                  ) : (
                                                                    <div
                                                                      style={{
                                                                        display:
                                                                          "flex",
                                                                        alignItems:
                                                                          "center",
                                                                        gap: "3px",
                                                                      }}
                                                                    >
                                                                      <i
                                                                        className="fas fa-times cqStudQrCheckIcon text-danger"
                                                                        title="Incorrect answer"
                                                                      />
                                                                      <span>
                                                                        {ans.label.replace(
                                                                          /[\])}[{(]/g,
                                                                          "",
                                                                        )}
                                                                      </span>
                                                                    </div>
                                                                  )}

                                                                  {shouldShowComma(
                                                                    index,
                                                                    paddedAnswers.length,
                                                                  ) && (
                                                                    <span
                                                                      style={{
                                                                        margin:
                                                                          "0 6px",
                                                                      }}
                                                                    >
                                                                      ,&nbsp;
                                                                    </span>
                                                                  )}
                                                                </span>
                                                              ),
                                                            )
                                                          ) : (
                                                            // No valid answer at all
                                                            <>
                                                              <div
                                                                style={{
                                                                  display:
                                                                    "flex",
                                                                  flexWrap:
                                                                    "nowrap",
                                                                  alignItems:
                                                                    "center",
                                                                  gap: "3px",
                                                                }}
                                                              >
                                                                <i
                                                                  className="fas fa-times cqStudQrCheckIcon text-danger"
                                                                  title="Not answered"
                                                                />
                                                                <span>N/A</span>
                                                              </div>
                                                              {isMultiSelect && (
                                                                <span
                                                                  style={{
                                                                    margin:
                                                                      "0 6px",
                                                                  }}
                                                                >
                                                                  ,
                                                                </span>
                                                              )}
                                                              {isMultiSelect && (
                                                                <div
                                                                  style={{
                                                                    display:
                                                                      "flex",
                                                                    flexWrap:
                                                                      "nowrap",
                                                                    alignItems:
                                                                      "center",
                                                                  }}
                                                                >
                                                                  <i
                                                                    className="fas fa-times cqStudQrCheckIcon text-danger"
                                                                    title="Not answered"
                                                                  />
                                                                  <span>
                                                                    N/A
                                                                  </span>
                                                                </div>
                                                              )}
                                                            </>
                                                          )}
                                                        </span>
                                                      </div>
                                                      <InnerHTML
                                                        html={
                                                          detailQRQues.promptText
                                                        }
                                                        className={
                                                          detailQRQues.ques_expand_status ===
                                                          true
                                                            ? "cqStudQrQuesTxtExpa cqStudQrQuesTxtMar col-xl-10 col-lg-9 col-md-9 col-sm-12 col-12 p-0 d-inline-block px-0 mt-xl-0 mt-lg-0 mt-md-0 mt-sm-2 mt-2 pl-xl-0 pl-lg-0 pl-md-0 pl-2"
                                                            : "cqStudQrQuesTxtShort cqStudQrQuesTxtMar col-xl-10 col-lg-9 col-md-9 col-sm-6 col-6 p-0 d-inline-block px-0 mt-0"
                                                        }
                                                      />
                                                    </div>
                                                    {detailQRQues.ques_expand_status ===
                                                    true ? (
                                                      <div
                                                        className="border-bottom mt-2 w-100"
                                                        style={{
                                                          marginLeft: "10%",
                                                        }}
                                                      >
                                                        {!hasValidAnswer && (
                                                          <span className="cqStudQrUnanswerText pl-xl-4 pl-lg-3 pl-md-3 pl-sm-2 pl-2">
                                                            You did not answer
                                                            this question.
                                                          </span>
                                                        )}
                                                        {isPartialAnswered && (
                                                          <span className="cqStudQrUnanswerText pl-xl-4 pl-lg-3 pl-md-3 pl-sm-2 pl-2">
                                                            Your answered this
                                                            question partially.
                                                          </span>
                                                        )}
                                                        {detailQRQues
                                                          .choiceInteraction
                                                          .simpleChoices &&
                                                          detailQRQues.choiceInteraction.simpleChoices.map(
                                                            (
                                                              detQRQuesOpt,
                                                              indexdetQRQuesOpt,
                                                            ) => {
                                                              const selectedAnswers =
                                                                detailQRQues.UserSelectedanswerList ||
                                                                [];

                                                              const isSelected =
                                                                selectedAnswers.some(
                                                                  (ans) =>
                                                                    ans.choice ===
                                                                    detQRQuesOpt.identifier,
                                                                );

                                                              const isCorrect =
                                                                Boolean(
                                                                  detQRQuesOpt.correct,
                                                                );
                                                              console.log({
                                                                detailQRQues,
                                                                option:
                                                                  detQRQuesOpt.identifier,
                                                                selected:
                                                                  detailQRQues.SelectedAnswer,
                                                                isSelected,
                                                                correctRaw:
                                                                  detQRQuesOpt.correct,
                                                                isCorrect,
                                                              });
                                                              const renderAnswerIcon =
                                                                () => {
                                                                  if (
                                                                    isSelected &&
                                                                    !isCorrect
                                                                  ) {
                                                                    return (
                                                                      <i
                                                                        className="fas fa-times cqStudQrCheckIcon text-danger pt-3"
                                                                        title="Incorrect answer"
                                                                        role="img"
                                                                      />
                                                                    );
                                                                  }

                                                                  if (
                                                                    isCorrect
                                                                  ) {
                                                                    return (
                                                                      <i
                                                                        className="fas fa-check cqStudQrCheckIcon pt-3"
                                                                        title="Correct answer"
                                                                        role="img"
                                                                      />
                                                                    );
                                                                  }

                                                                  return null;
                                                                };

                                                              return (
                                                                <div
                                                                  className="row"
                                                                  key={
                                                                    indexdetQRQuesOpt
                                                                  }
                                                                >
                                                                  <div className="col-11">
                                                                    <p className="cqStudQrOptionText p-2 mt-2">
                                                                      <span className="cqStudQrText d-flex flex-row">
                                                                        {
                                                                          detQRQuesOpt.label
                                                                        }
                                                                        <InnerHTML
                                                                          html={
                                                                            detQRQuesOpt.answerText
                                                                          }
                                                                        />
                                                                      </span>
                                                                    </p>
                                                                  </div>
                                                                  <div className="col-1 p-0">
                                                                    <span className="cqStudQrAnswerText">
                                                                      {renderAnswerIcon()}
                                                                    </span>
                                                                  </div>
                                                                </div>
                                                              );
                                                            },
                                                          )}
                                                        <div className="ml-4">
                                                          {detailQRQues.rationale &&
                                                          detailQRQues.rationale
                                                            .length > 0 ? (
                                                            <>
                                                              <p
                                                                className="cqStudQrTextQuizzes"
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                }}
                                                                role="heading"
                                                                aria-level="3"
                                                              >
                                                                Rationale:
                                                              </p>
                                                              <p className="cqStudQrTextQuizzes">
                                                                {detailQRQues.rationale.map(
                                                                  (
                                                                    detailQRQuesRat,
                                                                    indexdetailQRQuesRat,
                                                                  ) => {
                                                                    return (
                                                                      <InnerHTML
                                                                        key={
                                                                          indexdetailQRQuesRat
                                                                        }
                                                                        html={
                                                                          detailQRQuesRat.feedbackText
                                                                        }
                                                                      />
                                                                    );
                                                                  },
                                                                )}
                                                              </p>
                                                            </>
                                                          ) : null}
                                                          {detailQRQues.remediationLinks &&
                                                          detailQRQues
                                                            .remediationLinks
                                                            .length > 0 ? (
                                                            <>
                                                              <p
                                                                className="cqStudQrTextQuizzes"
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                }}
                                                                role="heading"
                                                                aria-level="3"
                                                              >
                                                                Recommended
                                                                Reading:
                                                              </p>
                                                              <p className="cqStudQrTextQuizzes">
                                                                <InnerHTML
                                                                  html={
                                                                    detailQRQues
                                                                      .remediationLinks[0]
                                                                      .remediationlinkText
                                                                  }
                                                                />
                                                              </p>
                                                            </>
                                                          ) : null}
                                                        </div>
                                                      </div>
                                                    ) : null}
                                                  </div>
                                                </li>
                                              </>
                                            );
                                          },
                                        )}
                                      </ol>
                                    </div>
                                  </div>
                                );
                              },
                            )}
                          </div>
                        </div>
                      ) : (
                        <div className="row border-bottom pb-2 mb-2">
                          <div className="col">
                            <button
                              style={{
                                border: "none",
                                padding: "0%",
                                background: "none",
                              }}
                              aria-expanded={expandAll}
                              aria-label={
                                expandAll
                                  ? "Collapse all questions"
                                  : "Expand all questions"
                              }
                              onClick={() =>
                                expandAll === true
                                  ? handleDetailResultOWExpandAll(false)
                                  : handleDetailResultOWExpandAll(true)
                              }
                            >
                              <span className="cqStudQrClassQuesExp">
                                {expandAll === true
                                  ? "Collapse all questions"
                                  : "Expand all questions"}
                              </span>
                            </button>
                            <ol
                              className="m-0 p-0"
                              style={{ listStyleType: "none" }}
                            >
                              {detailQuizResultOW.map(
                                (detailQRQuesOW, index) => {
                                  const rawUserAnswers =
                                    detailQRQuesOW.UserSelectedanswerList || [];

                                  // Remove invalid answers (empty choice, null, undefined)
                                  const validUserAnswers =
                                    rawUserAnswers.filter(
                                      (ans) =>
                                        ans.choice && ans.choice.trim() !== "",
                                    );

                                  const hasValidAnswer =
                                    validUserAnswers.length > 0;

                                  const isMultiSelect =
                                    detailQRQuesOW.itemTypeName === CHECKBOX;

                                  // Map: choiceId -> correct
                                  const answerMap = validUserAnswers.reduce(
                                    (acc, ans) => {
                                      acc[ans.choice] = ans.correct;
                                      return acc;
                                    },
                                    {},
                                  );
                                  const selectedAnswers =
                                    detailQRQuesOW.UserSelectedanswerList || [];

                                  const isSelected = validUserAnswers.some(
                                    (ans) =>
                                      ans.choice ===
                                      detailQRQuesOW.questionIdentifier,
                                  );
                                  const isCorrect = Boolean(
                                    detailQRQuesOW.correct,
                                  );
                                  const expectedCount = isMultiSelect ? 2 : 1;

                                  const paddedAnswers = [];

                                  Object.keys(answerMap).forEach((choiceId) => {
                                    const option =
                                      detailQRQuesOW.choiceInteraction.simpleChoices.find(
                                        (opt) => opt.identifier === choiceId,
                                      );

                                    if (!option) return;

                                    paddedAnswers.push({
                                      label: option.label,
                                      isCorrect: answerMap[choiceId] === true,
                                      isNA: false,
                                    });
                                  });

                                  // Pad with NA
                                  while (paddedAnswers.length < expectedCount) {
                                    paddedAnswers.push({ isNA: true });
                                  }

                                  const answeredCount = validUserAnswers.length;

                                  const correctCount = validUserAnswers.filter(
                                    (a) => a.correct,
                                  ).length;
                                  const rawAnsweredCount =
                                    validUserAnswers.length;
                                  const isPartialAnswered =
                                    isMultiSelect &&
                                    rawAnsweredCount > 0 &&
                                    rawAnsweredCount < expectedCount;
                                  isMultiSelect &&
                                    console.log(
                                      "isPartialAnswered",
                                      isPartialAnswered,
                                    );
                                  return (
                                    <>
                                      <li key={index}>
                                        <div className="card card-body">
                                          <div
                                            className="cqStudQrTextQuizzes row mb-2"
                                            tabIndex={0}
                                            role="button"
                                            aria-disabled={
                                              detailQRQuesOW.owques_expand_status ===
                                              true
                                                ? true
                                                : false
                                            }
                                            aria-expanded={
                                              detailQRQuesOW.owques_expand_status ===
                                              true
                                                ? true
                                                : false
                                            }
                                            onClick={() =>
                                              handleDetailResultOWExpandQues(
                                                detailQRQuesOW.questionOrder,
                                                detailQRQuesOW.owques_expand_status ===
                                                  true
                                                  ? false
                                                  : true,
                                              )
                                            }
                                            onKeyDown={(e) => {
                                              if (e.key === "Enter") {
                                                handleDetailResultOWExpandQues(
                                                  detailQRQuesOW.questionOrder,
                                                  detailQRQuesOW.owques_expand_status ===
                                                    true
                                                    ? false
                                                    : true,
                                                );
                                              }
                                            }}
                                          >
                                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                              <div
                                                className="cqStudQrDisplayBlock col-xl-1 col-lg-1 col-md-1 col-sm-2 col-2 pl-xl-3 pl-lg-2 pl-md-2 pl-0 pr-0"
                                                style={{ cursor: "pointer" }}
                                              >
                                                {detailQRQuesOW.questionOrder +
                                                  ". "}
                                              </div>
                                              <div
                                                className="col-xl-1 col-lg-2 col-md-2 col-sm-4 col-4 no-padding float-right"
                                                style={{ cursor: "pointer" }}
                                              >
                                                {/* <span className="cqStudQrAnswerText">
                                                  {hasValidAnswer ? (
                                                    detailQRQuesOW.choiceInteraction?.simpleChoices?.map(
                                                      (option) => {
                                                        if (
                                                          !answerMap.hasOwnProperty(
                                                            option.identifier,
                                                          )
                                                        )
                                                          return null;

                                                        const isCorrect =
                                                          answerMap[
                                                            option.identifier
                                                          ];

                                                        return (
                                                          <span
                                                            key={
                                                              option.identifier
                                                            }
                                                          >
                                                            {isCorrect ? (
                                                              <i
                                                                className="fas fa-check cqStudQrCheckIcon"
                                                                title="Correct answer"
                                                              ></i>
                                                            ) : (
                                                              <i
                                                                className="fas fa-times cqStudQrCheckIcon text-danger"
                                                                title="Incorrect answer"
                                                              ></i>
                                                            )}
                                                            <span>
                                                              {option.label.replace(
                                                                /[\])}[{(]/g,
                                                                "",
                                                              )}
                                                            </span>
                                                          </span>
                                                        );
                                                      },
                                                    )
                                                  ) : (
                                                    <div>
                                                      <i
                                                        className="fas fa-times cqStudQrCheckIcon text-danger"
                                                        title="Not answered"
                                                        // style={{
                                                        //   paddingRight: "12px",
                                                        // }}
                                                      ></i>
                                                      <span>N/A</span>
                                                    </div>
                                                  )}
                                                </span> */}
                                                <span
                                                  className="cqStudQrAnswerText"
                                                  style={{
                                                    display: "flex",
                                                    flexWrap: "nowrap",
                                                    gap: "0px",
                                                  }}
                                                >
                                                  {paddedAnswers.map(
                                                    (ans, index) => (
                                                      <span
                                                        key={index}
                                                        className="mr-2"
                                                        style={{
                                                          display: "flex",
                                                        }}
                                                      >
                                                        {ans.isNA ? (
                                                          <div
                                                            style={{
                                                              display: "flex",
                                                              alignItems:
                                                                "center",
                                                            }}
                                                          >
                                                            <i className="fas fa-times cqStudQrCheckIcon text-danger" />
                                                            <span>N/A</span>
                                                          </div>
                                                        ) : ans.isCorrect ? (
                                                          <div
                                                            style={{
                                                              display: "flex",
                                                              alignItems:
                                                                "center",
                                                            }}
                                                          >
                                                            <i className="fas fa-check cqStudQrCheckIcon" />
                                                            <span>
                                                              {ans.label.replace(
                                                                /[\])}[{(]/g,
                                                                "",
                                                              )}
                                                            </span>
                                                          </div>
                                                        ) : (
                                                          <div
                                                            style={{
                                                              display: "flex",
                                                              alignItems:
                                                                "center",
                                                            }}
                                                          >
                                                            <i className="fas fa-times cqStudQrCheckIcon text-danger" />
                                                            <span>
                                                              {ans.label.replace(
                                                                /[\])}[{(]/g,
                                                                "",
                                                              )}
                                                            </span>
                                                          </div>
                                                        )}

                                                        {shouldShowComma(
                                                          index,
                                                          paddedAnswers.length,
                                                        ) && (
                                                          <span
                                                            style={{
                                                              marginLeft: "8px",
                                                            }}
                                                          >
                                                            ,
                                                          </span>
                                                        )}
                                                      </span>
                                                    ),
                                                  )}
                                                </span>
                                              </div>
                                              <InnerHTML
                                                html={detailQRQuesOW.promptText}
                                                className={
                                                  detailQRQuesOW.owques_expand_status ===
                                                  true
                                                    ? "cqStudQrQuesTxtExpa cqStudQrQuesTxtMar col-xl-10 col-lg-9 col-md-9 col-sm-12 col-12 p-0 d-inline-block px-0 mt-xl-0 mt-lg-0 mt-md-0 mt-sm-2 mt-2 pl-xl-0 pl-lg-0 pl-md-0 pl-2"
                                                    : "cqStudQrQuesTxtShort cqStudQrQuesTxtMar col-xl-10 col-lg-9 col-md-9 col-sm-6 col-6 p-0 d-inline-block px-0 mt-0"
                                                }
                                              />
                                            </div>
                                            {detailQRQuesOW.owques_expand_status ===
                                            true ? (
                                              <div
                                                className="border-bottom mt-2 w-100"
                                                style={{ marginLeft: "10%" }}
                                              >
                                                {!hasValidAnswer && (
                                                  <span className="cqStudQrUnanswerText pl-xl-4 pl-lg-3 pl-md-3 pl-sm-2 pl-2">
                                                    You did not answer this
                                                    question.
                                                  </span>
                                                )}
                                                {isPartialAnswered && (
                                                  <span className="cqStudQrUnanswerText pl-xl-4 pl-lg-3 pl-md-3 pl-sm-2 pl-2">
                                                    Your answered this question
                                                    partially.
                                                  </span>
                                                )}
                                                {detailQRQuesOW.choiceInteraction.simpleChoices.map(
                                                  (option, idx) => {
                                                    const isSelected =
                                                      validUserAnswers.some(
                                                        (ans) =>
                                                          ans.choice ===
                                                          option.identifier,
                                                      );

                                                    const isCorrect =
                                                      option.correct === true;

                                                    return (
                                                      <div
                                                        className="row"
                                                        key={idx}
                                                      >
                                                        <div className="col-11">
                                                          <p className="cqStudQrOptionText p-2 mt-2">
                                                            <span className="cqStudQrText d-flex flex-row">
                                                              {option.label}
                                                              <InnerHTML
                                                                html={
                                                                  option.answerText
                                                                }
                                                              />
                                                            </span>
                                                          </p>
                                                        </div>

                                                        <div className="col-1 p-0">
                                                          <span className="cqStudQrAnswerText">
                                                            {isSelected &&
                                                              !isCorrect && (
                                                                <i
                                                                  className="fas fa-times cqStudQrCheckIcon text-danger pt-3"
                                                                  title="Incorrect answer"
                                                                />
                                                              )}

                                                            {isCorrect && (
                                                              <i
                                                                className="fas fa-check cqStudQrCheckIcon pt-3"
                                                                title="Correct answer"
                                                              />
                                                            )}
                                                          </span>
                                                        </div>
                                                      </div>
                                                    );
                                                  },
                                                )}

                                                <div className="ml-4">
                                                  {detailQRQuesOW.rationale &&
                                                  detailQRQuesOW.rationale
                                                    .length > 0 ? (
                                                    <>
                                                      <p
                                                        className="cqStudQrTextQuizzes"
                                                        style={{
                                                          fontWeight: "bold",
                                                        }}
                                                        role="heading"
                                                        aria-level="3"
                                                      >
                                                        Rationale:
                                                      </p>
                                                      <p className="cqStudQrTextQuizzes">
                                                        {detailQRQuesOW.rationale.map(
                                                          (
                                                            detailQRQuesOWrat,
                                                            indexdetailQRQuesOWrat,
                                                          ) => {
                                                            return (
                                                              <InnerHTML
                                                                key={
                                                                  indexdetailQRQuesOWrat
                                                                }
                                                                html={
                                                                  detailQRQuesOWrat.feedbackText
                                                                }
                                                              />
                                                            );
                                                          },
                                                        )}
                                                      </p>
                                                    </>
                                                  ) : null}
                                                  {detailQRQuesOW.remediationLinks &&
                                                  detailQRQuesOW
                                                    .remediationLinks.length >
                                                    0 ? (
                                                    <>
                                                      <p
                                                        className="cqStudQrTextQuizzes"
                                                        style={{
                                                          fontWeight: "bold",
                                                        }}
                                                        role="heading"
                                                        aria-level="3"
                                                      >
                                                        Recommended Reading:
                                                      </p>
                                                      <p className="cqStudQrTextQuizzes">
                                                        <InnerHTML
                                                          html={
                                                            detailQRQuesOW
                                                              .remediationLinks[0]
                                                              .remediationlinkText
                                                          }
                                                        />
                                                      </p>
                                                    </>
                                                  ) : null}
                                                </div>
                                              </div>
                                            ) : null}
                                          </div>
                                        </div>
                                      </li>
                                    </>
                                  );
                                },
                              )}
                            </ol>
                          </div>
                        </div>
                      )}
                    </>
                  ) : null}
                </div>
              )}
            </div>
          </div>
        </div>
      </main>
    </>
  );
}
